// import { useEffect, useState } from 'react';
// import ExtensionFilter from './ExtensionFilter/ExtensionFilter';
// import { extensionFilterData } from '../../data/data';
// import { Item, SectionsProps } from '../../types/types';
// import Divider from '../../components/Divider/Divider';
// import { motion } from 'framer-motion';
// import Button from '../Button/Button';
// const Gaming: React.FC<SectionsProps> = ({ openModal }) => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [extensionFilter] = useState<Item[]>(extensionFilterData);
//   const [activeIndex, setActiveIndex] = useState<number>(0);
//   const [activeText, setActiveText] = useState<string | undefined>(
//     extensionFilter[0].text
//   );
//   const [activeImg, setActiveImg] = useState<string | undefined>(
//     extensionFilter[0].img
//   );

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 767.98) {
//         setIsMobile(true);
//       } else {
//         setIsMobile(false);
//       }
//     };
//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveIndex((prevIndex) => (prevIndex + 1) % extensionFilter.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [extensionFilter.length]);

//   useEffect(() => {
//     setActiveText(extensionFilter[activeIndex].text);
//     setActiveImg(extensionFilter[activeIndex].img);
//   }, [extensionFilter, activeIndex]);

//   return (
//     <section className='gaming'>
//       <Divider />
//       <div className='gaming__container'>
//         <div className='gaming__wrap'>
//           <div className='gaming__info'>
//             <h2 className='gaming__title title color'>
//               Empowering&nbsp;
//               <motion.span
//                 className='title '
//                 initial={{
//                   opacity: 0,
//                   color: '#747283',
//                 }}
//                 animate={{
//                   opacity: 1,
//                   color: '#ffffff',
//                 }}
//                 transition={{
//                   opacity: { duration: 5 },
//                   color: { duration: 2 },
//                 }}
//                 key={activeText}
//               >
//                 {activeText || 'Online gaming'}
//               </motion.span>
//               Business Growth
//             </h2>
//             {!isMobile && (
//               <ExtensionFilter
//                 className='extension'
//                 items={extensionFilter}
//                 activeIndex={activeIndex}
//               />
//             )}
//             <p className='gaming__text text-large'>
//               We are well-versed in the payment needs of numerous business
//               types. Discover how our solutions can benefit
//               <span className='gaming__text--color text-large'>
//                 &nbsp;your unique business.
//               </span>
//             </p>
//           </div>
//           <div className='gaming__img'>
//             {activeImg && <img src={activeImg} alt='' />}
//           </div>
//         </div>
//         {isMobile && (
//           <ExtensionFilter
//             className='extension'
//             items={extensionFilter}
//             activeIndex={activeIndex}
//           />
//         )}
//         <Button onClick={openModal} className='gaming__button'>
//           Find out more
//         </Button>
//       </div>
//     </section>
//   );
// };

// export default Gaming;
import { MouseEvent, useEffect, useState } from 'react';
import ExtensionFilter from './ExtensionFilter/ExtensionFilter';
import { extensionFilterData } from '../../data/data';
import { Item, ClickProps, SectionsProps } from '../../types/types';
import Divider from '../../components/Divider/Divider';
import { motion } from 'framer-motion';
import Button from '../Button/Button';
const checkIsMobile = (): boolean => {
  return window.innerWidth <= 767.98;
};
const Gaming: React.FC<ClickProps & SectionsProps> = ({ openModal }) => {
  const [isMobile, setIsMobile] = useState<boolean>(checkIsMobile());
  const [activeItem, setActiveItem] = useState<HTMLLIElement | null>(null);
  const [extensionFilter, setExtensionFilter] =
    useState<Item[]>(extensionFilterData);
  const onClick = (e: MouseEvent<HTMLLIElement>): void => {
    const target = e.currentTarget as HTMLLIElement;

    const extensionFilterCopy = extensionFilter.map((item: Item) => {
      if (item.default && item.id !== parseInt(target.dataset.id || '', 10)) {
        return {
          ...item,
          default: false,
        };
      }
      return item;
    });

    if (activeItem !== null) {
      activeItem.classList.remove('active');
    }
    target.classList.add('active');
    setActiveItem(target);
    setExtensionFilter(extensionFilterCopy);
  };
  const activeText = extensionFilter.find(
    (item) => item.text === activeItem?.textContent
  )?.text;
  const activeImg = extensionFilter.find(
    (item) => item.text === activeItem?.textContent
  )?.img;
  const defaultImg = extensionFilterData.find(
    (item: Item) => item.default
  )?.img;
  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(checkIsMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <section className='gaming'>
      <Divider />
      <div className='gaming__container'>
        <div className='gaming__wrap'>
          <div className='gaming__info'>
            <h2 className='gaming__title title color'>
              Empowering&nbsp;
              <motion.span
                className='gaming__title title '
                initial={{
                  // opacity: 0,
                  // color: '#747283',
                  scale: 0,
                }}
                animate={{
                  // opacity: 1,
                  // color: '#ffffff',
                  scale: 1,
                }}
                transition={{
                  // opacity: { duration: 2 },
                  // color: { duration: 2 },
                }}
                key={activeText}
              >
                {activeText || 'Online gaming'}
              </motion.span>
              Business Growth
            </h2>
            {!isMobile && (
              <ExtensionFilter
                className='extension'
                items={extensionFilter}
                onClick={onClick}
              />
            )}
            <p className='gaming__text text-large'>
              We are well-versed in the payment needs of numerous business
              types. Discover how our solutions can benefit
              <span className='gaming__text--color text-large'>
                &nbsp;your unique business.
              </span>
            </p>
          </div>
          <div className='gaming__img'>
            {activeImg || defaultImg ? (
              <img
                src={activeImg || defaultImg}
                alt={activeItem?.textContent || ''}
              />
            ) : null}
          </div>
        </div>
        {isMobile && (
          <ExtensionFilter
            className='extension'
            items={extensionFilter}
            onClick={onClick}
          />
        )}
        <Button onClick={openModal} className='gaming__button'>
          Find out more
        </Button>
      </div>
    </section>
  );
};
export default Gaming;
